export default __webpack_public_path__ + "static/whyinsurance-thumbnail-5dd9aa2ca1ca604dfeb06bda5ae8aacf.png";